"use strict";

// uses jQuery

const BillingDetailsFilledInCheckboxSelector = '#frm-deliveryPaymentAddress-addressForm-billingDetailsFilledIn';
const BillingPostalAddressCountrySelector = '#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-country';
const CompanyNameSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-companyName';
const ReverseChargeCompanyRegNumberSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-companyRegNumber';
const ReverseChargeTaxIdNumberSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-taxIdNumber';
const ReverseChargeVatIdNumberSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-vatIdNumber';
const ReverseChargeAppliedCheckboxSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-isReverseChargeApplied';
const ReverseChargeValidationMessageSelector = '#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-reverseChargeValidationMessage';
const ContactGivenNameSelector = '#frm-deliveryPaymentAddress-addressForm-contactPersonName-givenName';
const ContactFamilyNameSelector = '#frm-deliveryPaymentAddress-addressForm-contactPersonName-familyName';
const FormControlSelector = 'input, select, textarea, button';
const BillingDetailsDisabledDataAttribute = 'data-km-billing-details-disabled';
(function (window, factory) {
  window.KM = window.KM || {};
  factory(window.KM, window.jQuery);
})(window, function (KM, $) {
  'use strict';

  var findAddressForm = function () {
    var $form = $('#km-deliveryPaymentAddressControl-addressForm');
    return $form.length ? $form : null;
  };
  var initBillingDetailsFilledInCheckbox = function ($form) {
    var $checkbox = $(BillingDetailsFilledInCheckboxSelector, $form);
    if ($checkbox.length && $checkbox.className?.includes('hidden')) {
      $checkbox.closest('tr').addClass('hidden');
    }
    var autocompleteValuesByIndex = {};
    var $tbody = $checkbox.closest('tbody');
    var $tr = $checkbox.closest('tr');
    var $elements = $('tr', $tbody).not($tr);
    $.each($elements, function (rowIndex, element) {
      $('input', element).each(function (index, input) {
        autocompleteValuesByIndex[rowIndex] = input.getAttribute('autocomplete');
      });
    });
    $checkbox.unbind('change').change(function () {
      if ($checkbox.is(':checked')) {
        $elements.show();
        $.each($elements, function (rowIndex, element) {
          $(FormControlSelector, element).each(function (index, input) {
            input.setAttribute('autocomplete', autocompleteValuesByIndex[rowIndex]);
            input.removeAttribute('readonly');
            if (input.getAttribute(BillingDetailsDisabledDataAttribute) === '1') {
              input.removeAttribute('disabled');
              input.removeAttribute(BillingDetailsDisabledDataAttribute);
            }
          });
        });
      } else {
        $.each($elements, function (rowIndex, element) {
          element.setAttribute('style', 'display:none !important');
          $(FormControlSelector, element).each(function (index, input) {
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('readonly', '');
            if (!input.disabled) {
              input.setAttribute(BillingDetailsDisabledDataAttribute, '1');
              input.setAttribute('disabled', '');
            }
          });
        });
      }
      $(ReverseChargeAppliedCheckboxSelector, $form).triggerHandler('change');
    }).triggerHandler('change');
  };
  const ReverseChargeValidationDebounceDelay = 1000;
  let reverseChargeValidationAbortController = null;
  let reverseChargeValidationTimeoutId = null;
  const normalizeReverseChargeValue = value => `${value ?? ''}`.replace(/\s+/g, '');
  const getTrimmedFieldValue = $field => {
    const value = $field.val();
    return typeof value === 'string' ? value.trim() : '';
  };
  const getReverseChargeValidationField = $form => {
    const $country = $form.find(BillingPostalAddressCountrySelector);
    const countryCode = $country.val();
    if (($country.data('vat-id-country-codes') ?? []).includes(countryCode)) {
      return $form.find(ReverseChargeVatIdNumberSelector);
    }
    if (($country.data('tax-id-country-codes') ?? []).includes(countryCode)) {
      return $form.find(ReverseChargeTaxIdNumberSelector);
    }
    return $form.find(ReverseChargeCompanyRegNumberSelector);
  };
  const clearReverseChargeValidation = () => {
    if (reverseChargeValidationTimeoutId !== null) {
      window.clearTimeout(reverseChargeValidationTimeoutId);
      reverseChargeValidationTimeoutId = null;
    }
    if (reverseChargeValidationAbortController) {
      reverseChargeValidationAbortController.abort();
      reverseChargeValidationAbortController = null;
    }
  };
  const requestReverseChargeValidation = ($form, validateUrl) => {
    const formElement = $form.get(0);
    if (!formElement) {
      return;
    }
    clearReverseChargeValidation();
    reverseChargeValidationAbortController = new AbortController();
    const currentAbortController = reverseChargeValidationAbortController;
    const formData = new FormData(formElement);
    formData.delete('_do');
    const field = getReverseChargeValidationField($form).get(0);
    if (field?.name) {
      formData.set(field.name, normalizeReverseChargeValue(field.value));
    }
    showReverseChargeValidationLoader($form);
    fetch(validateUrl, {
      method: 'POST',
      headers: {
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: formData,
      credentials: 'same-origin',
      signal: currentAbortController.signal
    }).then(response => {
      if (!response.ok) {
        throw new Error(`Reverse charge validation failed with HTTP ${response.status}`);
      }
      return response.json();
    }).then(payload => {
      renderReverseChargeValidationMessage($form, payload);
    }).catch(error => {
      if (error.name === 'AbortError') {
        return;
      }
      console.error(error);
    }).finally(() => {
      if (reverseChargeValidationAbortController === currentAbortController) {
        reverseChargeValidationAbortController = null;
      }
    });
  };
  const scheduleReverseChargeValidation = ($form, validateUrl) => {
    clearReverseChargeValidation();
    reverseChargeValidationTimeoutId = window.setTimeout(() => {
      reverseChargeValidationTimeoutId = null;
      requestReverseChargeValidation($form, validateUrl);
    }, ReverseChargeValidationDebounceDelay);
  };
  const renderReverseChargeValidationMessage = ($form, validation) => {
    const $message = $(ReverseChargeValidationMessageSelector, $form);
    if (!$message.length) {
      return;
    }
    const $row = $message.closest('tr');
    const validationHtml = typeof validation === 'string' ? validation : validation?.html;
    if (!validationHtml) {
      $message.html('<div class="kvikymart-scdpa-ajax-loader"></div>').attr('hidden', 'hidden');
      $row.hide();
      return;
    }
    $row.removeAttr('hidden');
    $row.removeAttr('style');
    $message.html(validationHtml).removeAttr('hidden');
    $row.show();
  };
  const showReverseChargeValidationLoader = $form => {
    const $message = $(ReverseChargeValidationMessageSelector, $form);
    if (!$message.length || !window.km_spinner) {
      return;
    }
    const $row = $message.closest('tr');
    $row.removeAttr('hidden');
    $row.removeAttr('style');
    $message.html(`<div class="kvikymart-scdpa-ajax-loader visible">${window.km_spinner.html}</div>`).removeAttr('hidden');
    $row.show();
  };
  const initReverseChargeAppliedValidation = $form => {
    const $checkbox = $(ReverseChargeAppliedCheckboxSelector, $form);
    const validateUrl = $form.data('reverse-charge-validate-url');
    const $validationFields = $([ReverseChargeCompanyRegNumberSelector, ReverseChargeTaxIdNumberSelector, ReverseChargeVatIdNumberSelector].join(', '), $form);
    if (!$checkbox.length || !validateUrl) {
      return;
    }
    let lastValidationSignature = null;
    clearReverseChargeValidation();
    renderReverseChargeValidationMessage($form, null);
    const validate = debounced => {
      const $billingDetailsFilledInCheckbox = $(BillingDetailsFilledInCheckboxSelector, $form);
      if ($billingDetailsFilledInCheckbox.length && !$billingDetailsFilledInCheckbox.is(':checked')) {
        lastValidationSignature = null;
        clearReverseChargeValidation();
        renderReverseChargeValidationMessage($form, null);
        return;
      }
      if (!$checkbox.is(':checked')) {
        lastValidationSignature = null;
        clearReverseChargeValidation();
        renderReverseChargeValidationMessage($form, null);
        return;
      }
      const $field = getReverseChargeValidationField($form);
      const signature = normalizeReverseChargeValue($field.val());
      if ($field.length && signature === lastValidationSignature) {
        return;
      }
      lastValidationSignature = signature;
      if (debounced) {
        scheduleReverseChargeValidation($form, validateUrl);
        return;
      }
      requestReverseChargeValidation($form, validateUrl);
    };
    $checkbox.off('change.kmReverseChargeAppliedValidation').on('change.kmReverseChargeAppliedValidation', () => validate(false));
    $validationFields.off('input.kmReverseChargeAppliedValidation change.kmReverseChargeAppliedValidation').on('input.kmReverseChargeAppliedValidation change.kmReverseChargeAppliedValidation', () => {
      validate(true);
    });
    $form.off('click.kmReverseChargeAppliedValidationRetry', '.kvikymart-reverse-charge-validation-retry').on('click.kmReverseChargeAppliedValidationRetry', '.kvikymart-reverse-charge-validation-retry', e => {
      e.preventDefault();
      const $billingDetailsFilledInCheckbox = $(BillingDetailsFilledInCheckboxSelector, $form);
      if ($billingDetailsFilledInCheckbox.length && !$billingDetailsFilledInCheckbox.is(':checked') || !$checkbox.is(':checked')) {
        return;
      }
      requestReverseChargeValidation($form, validateUrl);
    });
    validate(false);
  };
  var initDeliveryDetailsFilledInCheckbox = function ($form) {
    var $checkbox = $('#frm-deliveryPaymentAddress-addressForm-deliveryDetailsFilledIn', $form);
    var autocompleteValuesByIndex = {};
    var $tbody = $checkbox.closest('tbody');
    var $tr = $checkbox.closest('tr');
    var $allRows = $('tr', $tbody);
    var currentIndex = $allRows.index($tr);
    var $elements = $allRows.slice(currentIndex + 1);
    let isAnyFieldFilled = false;
    $.each($elements, function (rowIndex, element) {
      $('input', element).each(function (index, input) {
        autocompleteValuesByIndex[rowIndex] = input.getAttribute('autocomplete');
        if (input.value) {
          isAnyFieldFilled = true;
        }
      });
    });
    if (isAnyFieldFilled) {
      $checkbox.prop('checked', true);
    }
    $checkbox.off('change').on('change', function () {
      if ($checkbox.is(':checked')) {
        $elements.show();
        $.each($elements, function (rowIndex, element) {
          $('input', element).each(function (index, input) {
            input.setAttribute('autocomplete', autocompleteValuesByIndex[rowIndex]);
            input.removeAttribute('readonly');
          });
        });
      } else {
        $.each($elements, function (rowIndex, element) {
          element.setAttribute('style', 'display:none !important');
          $('input', element).each(function (index, input) {
            input.setAttribute('autocomplete', 'off');
            input.setAttribute('readonly', '');
          });
        });
      }
    }).triggerHandler('change');
  };
  var initDeliveryDetailsSameAsBillingCheckbox = function ($form) {
    var $checkbox = $('#frm-deliveryPaymentAddress-addressForm-deliveryDetailsSameAsBilling', $form);
    $checkbox.unbind('change').change(function () {
      var $tbody = $checkbox.closest('tbody');
      var $tr = $checkbox.closest('tr');
      var $elements = $('tr', $tbody).not($tr);
      if (!$checkbox.is(':checked')) {
        $elements.show();
      } else {
        $.each($elements, function (index, element) {
          element.setAttribute('style', 'display:none !important');
        });
      }
    }).triggerHandler('change');
  };
  var initDynamicPlaceholders = function ($form) {
    var valToPlaceholder = {
      [ContactGivenNameSelector]: '#frm-deliveryPaymentAddress-addressForm-deliveryPersonName-givenName',
      [ContactFamilyNameSelector]: '#frm-deliveryPaymentAddress-addressForm-deliveryPersonName-familyName',
      '#tel-national': '#frm-deliveryPaymentAddress-addressForm-deliveryPhoneNumber',
      '#email': '#frm-deliveryPaymentAddress-addressForm-deliveryEmailAddress'
    };
    jQuery.each(valToPlaceholder, function (from, to) {
      var $from = $(from, $form);
      var $to = $(to, $form);
      $from.on('change keyup', function () {
        $to.attr('placeholder', $from.val());
      });
      $from.triggerHandler('change');
    });

    // Contact PhoneNumber-CountryPrefix > Delivery PhoneNumber-CountryPrefix
    var countryPrefixFrom = $('#tel-national-countryPrefix', $form);
    var countryPrefixTo = $('#frm-deliveryPaymentAddress-addressForm-deliveryPhoneNumber-countryPrefix', $form);
    countryPrefixFrom.on('change', function () {
      countryPrefixTo.val(countryPrefixFrom.val());
    });
    countryPrefixFrom.triggerHandler('change');
  };
  const initCheckboxForFieldset = function ($form) {
    const checkbox = $('[data-is-for-fieldset="1"]', $form);
    if (!checkbox.length) {
      return; // No checkbox for fieldset found
    }
    const areInputValuesEmpty = inputs => {
      return inputs.toArray().every(input => !$(input).val());
    };
    const displayLabel = (label, display) => {
      label.css({
        opacity: display ? 1 : 0,
        top: display ? 0 : '-8px',
        pointerEvents: display ? 'all' : 'none'
      });
    };
    const label = checkbox.parent();
    const fieldset = checkbox.closest('fieldset');
    const inputs = fieldset.find('input, textarea, select').not('[data-is-for-fieldset]'); // Exclude checkbox for fieldset itself

    if (!inputs.length) {
      return; // No inputs found
    }

    // If all inputs are empty, hide checkbox otherwise check it
    if (areInputValuesEmpty(inputs)) {
      displayLabel(label, false);
    } else {
      checkbox.prop('checked', true);
    }
    label.css('transition', '125ms all linear'); // Enable animation

    // If all inputs are empty, change checkbox state and visibility accordingly
    inputs.on('keyup', () => {
      if (!areInputValuesEmpty(inputs)) {
        displayLabel(label, true);
        checkbox.prop('checked', true);
      } else {
        displayLabel(label, false);
        checkbox.prop('checked', false);
      }
    });

    // If checkbox is checked, enable inputs otherwise disable them
    checkbox.on('change', () => {
      inputs.prop('disabled', !checkbox.is(':checked'));
      inputs.css('text-decoration', !checkbox.is(':checked') ? 'line-through' : 'none');
    });

    // Page load/reload with cached data
    checkbox.triggerHandler('change');
    if (areInputValuesEmpty(inputs)) {
      if (!checkbox.is(':checked')) {
        inputs.prop('disabled', false);
        inputs.css('text-decoration', 'none');
      }
    } else {
      if (!checkbox.is(':checked')) {
        inputs.prop('disabled', true);
        inputs.css('text-decoration', 'line-through');
      }
    }
  };
  const initSimpleContactInfo = $form => {
    const $givenName = $form.find(ContactGivenNameSelector);
    const $table = $givenName.closest('table');
    if (!$table.length || $table.find('.error').length > 0) {
      return;
    }
    const $inputs = $table.find('input[required]');
    const $countryPrefix = $form.find('#tel-national-countryPrefix');
    const $nationalNumber = $form.find('#tel-national');
    const allFilled = $inputs.toArray().every(input => input.value.trim()) && $countryPrefix.val() && getTrimmedFieldValue($nationalNumber);
    if (!allFilled) {
      return;
    }
    const contactInfo = {
      givenName: getTrimmedFieldValue($givenName),
      familyName: getTrimmedFieldValue($form.find(ContactFamilyNameSelector)),
      email: getTrimmedFieldValue($form.find('#email')),
      phone: `+${$countryPrefix.val()}${getTrimmedFieldValue($nationalNumber)}`,
      changeText: $form.attr('data-change-button-text')
    };
    upsertSimpleView($table, `
        <p><strong>${contactInfo.givenName} ${contactInfo.familyName}</strong></p>
        <p>${contactInfo.email}, ${contactInfo.phone}</p>
    `, contactInfo.changeText);
    hideRows($table);
  };
  const initSimpleDeliveryInfo = $form => {
    const $street = $form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPostalAddress-streetAndHouseNumber');
    const $table = $street.closest('table');
    if (!$table.length || $table.find('.error').length > 0) {
      return;
    }
    const requiredFields = [$street, $form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPostalAddress-city'), $form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPostalAddress-postalCode')];
    if (!requiredFields.every($field => getTrimmedFieldValue($field))) {
      return;
    }
    const $deliveryCountryPrefix = $form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPhoneNumber-countryPrefix');
    const $deliveryPhoneNumber = $form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPhoneNumber');
    const deliveryInfo = {
      street: getTrimmedFieldValue($street),
      city: getTrimmedFieldValue(requiredFields[1]),
      postalCode: getTrimmedFieldValue(requiredFields[2]),
      details: getTrimmedFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPostalAddress-detailedDescription')),
      name: [getTrimmedFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPersonName-givenName')), getTrimmedFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-deliveryPersonName-familyName'))].filter(Boolean).join(' '),
      company: getTrimmedFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-deliveryCompanyName-companyName')),
      email: getTrimmedFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-deliveryEmailAddress')),
      phone: $deliveryCountryPrefix.val() && getTrimmedFieldValue($deliveryPhoneNumber) ? `+${$deliveryCountryPrefix.val()}${getTrimmedFieldValue($deliveryPhoneNumber)}` : '',
      changeText: $form.attr('data-change-button-text')
    };
    const contactLine = [deliveryInfo.email, deliveryInfo.phone].filter(Boolean).join(', ');
    const extraLines = [deliveryInfo.name && `<p>${deliveryInfo.name}</p>`, deliveryInfo.company && `<p>${deliveryInfo.company}</p>`, contactLine && `<p>${contactLine}</p>`].filter(Boolean).join('');
    upsertSimpleView($table, `
        <p>${deliveryInfo.street}, ${deliveryInfo.city}, ${deliveryInfo.postalCode}</p>
        ${deliveryInfo.details ? `<p>${deliveryInfo.details}</p>` : ''}
        ${extraLines}
    `, deliveryInfo.changeText);
    hideRows($table);
  };
  const initSimpleBillingInfo = $form => {
    const $companyName = $form.find(CompanyNameSelector);
    const $table = $companyName.closest('table');
    if (!$table.length || $table.find('.error').length > 0) {
      return;
    }
    const requiredFields = [$companyName, $form.find('#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-streetAndHouseNumber'), $form.find('#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-city'), $form.find('#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-postalCode')];
    if (!requiredFields.every($field => getTrimmedFieldValue($field))) {
      return;
    }
    const getLabelText = id => {
      return $form.find(`label[for="${id}"]`).text().trim().replace(/:$/, '');
    };
    const getVisibleFieldValue = $field => {
      const $row = $field.closest('tr');
      return $row.css('display') === 'none' ? '' : getTrimmedFieldValue($field);
    };
    const billingInfo = {
      companyName: getTrimmedFieldValue($companyName),
      regNumber: getVisibleFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-companyRegNumber')),
      taxId: getVisibleFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-taxIdNumber')),
      vatId: getVisibleFieldValue($form.find('#frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-vatIdNumber')),
      country: $form.find('#frm-deliveryPaymentAddress-addressForm-billingPostalAddress-country option:selected').text(),
      street: getTrimmedFieldValue(requiredFields[1]),
      city: getTrimmedFieldValue(requiredFields[2]),
      postalCode: getTrimmedFieldValue(requiredFields[3]),
      changeText: $form.attr('data-change-button-text')
    };
    upsertSimpleView($table, `
        <p><strong>${billingInfo.companyName}</strong></p>
        <p>
            ${billingInfo.regNumber ? `${getLabelText('frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-companyRegNumber')}: ${billingInfo.regNumber}<br>` : ''}
            ${billingInfo.taxId ? `${getLabelText('frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-taxIdNumber')}: ${billingInfo.taxId}<br>` : ''}
            ${billingInfo.vatId ? `${getLabelText('frm-deliveryPaymentAddress-addressForm-billingCompanyIdentification-vatIdNumber')}: ${billingInfo.vatId}<br>` : ''}
            ${billingInfo.country}, ${billingInfo.street}, ${billingInfo.city}, ${billingInfo.postalCode}
        </p>
    `, billingInfo.changeText);
    hideRows($table);
  };
  const createSimpleView = (content, changeText) => {
    return $(`
            <table>
                <tr>
                    <th></th>
                    <td>
                        <div class="shoppingCartSimpleDetails">
                            ${content}
                            <button type="button" class="shoppingCartSimpleDetails__changeButton linkUnderlineOnHover">${changeText}</button>
                        </div>
                    </td>
                </tr>
            </table>
        `);
  };

  // Update if exists, otherwise create new
  const upsertSimpleView = ($table, content, changeText) => {
    const $simpleView = createSimpleView(content, changeText);
    const $existingSimpleView = $table.data('km-simple-view');
    setupToggleView($simpleView, $table);
    if ($existingSimpleView?.length) {
      $existingSimpleView.replaceWith($simpleView);
    } else {
      $table.before($simpleView);
    }
    $table.data('km-simple-view', $simpleView);
  };
  const hideRows = $table => {
    const $rows = $table.find('tr');
    setTimeout(function () {
      $rows.each(function () {
        const $row = $(this);
        if ($row.find('input[name="billingCompanyIdentification[isReverseChargeApplied]"]').length === 0 && $row.find(ReverseChargeValidationMessageSelector).length === 0) {
          $row.hide();
        }
      });
    }, 40); // Timeout to avoid conflict with BillingAddressFormContainer
  };
  const showRows = $table => {
    const $rows = $table.find('tr');
    $rows.each(function () {
      const $row = $(this);
      if ($row.hasClass('hidden')) {
        return;
      }
      $row.show();
    });
    var $checkbox = $(BillingDetailsFilledInCheckboxSelector, $table);
    if ($checkbox) {
      $checkbox.triggerHandler('change');
    }
  };
  const setupToggleView = ($simpleView, $originalTable) => {
    $simpleView.find('.linkUnderlineOnHover').on('click', () => {
      $simpleView.remove();
      $originalTable.removeData('km-simple-view');
      showRows($originalTable);
    });
  };
  const initAutoFillCompanyName = $form => {
    const $companyNameInput = $form.find(CompanyNameSelector);
    const companyNameInitialValue = getTrimmedFieldValue($companyNameInput);
    if (!$companyNameInput.length || companyNameInitialValue || $companyNameInput.data('km-auto-fill-bound')) {
      return;
    }
    $companyNameInput.data('km-auto-fill-bound', true);
    const $givenName = $form.find(ContactGivenNameSelector);
    const $familyName = $form.find(ContactFamilyNameSelector);
    let isManuallyEdited = false;
    let lastAutoFilledCompanyName = companyNameInitialValue;
    const updateCompanyName = () => {
      if (isManuallyEdited) {
        return;
      }
      const currentCompanyName = getTrimmedFieldValue($companyNameInput);
      if (currentCompanyName && currentCompanyName !== lastAutoFilledCompanyName) {
        return;
      }
      const given = getTrimmedFieldValue($givenName);
      const family = getTrimmedFieldValue($familyName);
      lastAutoFilledCompanyName = [given, family].filter(Boolean).join(' ');
      $companyNameInput.val(lastAutoFilledCompanyName);
    };
    $companyNameInput.on('input', function () {
      if (getTrimmedFieldValue($(this)) !== `${getTrimmedFieldValue($givenName)} ${getTrimmedFieldValue($familyName)}`.trim()) {
        isManuallyEdited = true;
      }
    });
    $givenName.on('input change', updateCompanyName);
    $familyName.on('input change', updateCompanyName);
    updateCompanyName();
  };
  const initSubmitButtonHandler = $form => {
    const $submitBtn = $form.find(':submit');
    if ($submitBtn.data('kvik-submit-click-handler-attached')) {
      return;
    }
    $submitBtn.on('click', function (e) {
      e.preventDefault();
      const form = $form[0];
      if (!form) {
        return;
      }
      const isValid = window.Nette && typeof window.Nette.validateForm === 'function' ? window.Nette.validateForm(form, true) : true;
      if (!isValid) {
        $('.shoppingCartSimpleDetails').each(function () {
          const $wrapper = $(this).closest('table');
          const $originalTable = $wrapper.next('table');
          $wrapper.remove();
          showRows($originalTable);
        });
        window.Nette.validateForm(form); // To display error after the inputs are unwrapped

        return;
      }
      $submitBtn.click(); // Intentionally to re-trigger Nette forms scroll to input, because DOM element dimensions change when simple details are unwrapped
    });
    $submitBtn.data('kvik-submit-click-handler-attached', true);
  };
  const initAddressForm = () => {
    const $form = findAddressForm();
    if ($form === null) {
      return;
    }
    if ($form.attr('data-km-address-form-initialized') !== '1') {
      $form.attr('data-km-address-form-initialized', '1');
      initDeliveryDetailsSameAsBillingCheckbox($form);
      initDeliveryDetailsFilledInCheckbox($form);
      initBillingDetailsFilledInCheckbox($form);
      initDynamicPlaceholders($form);
      initCheckboxForFieldset($form);
      initSimpleContactInfo($form);
      initSimpleDeliveryInfo($form);
      initSimpleBillingInfo($form);
      initAutoFillCompanyName($form);
      initSubmitButtonHandler($form);
      initReverseChargeAppliedValidation($form);
    }
  };
  document.addEventListener('KMDeliveryPaymentAddressControl.addressFormLoaded', function (event) {
    initAddressForm();
  });
  $(window).on('pageshow', function () {
    initAddressForm();
  });
});